import { CheckIcon, CopyIcon } from 'lucide-react';
import { useState } from 'react';
import { Button } from './button';

interface CopyTextProps {
  label: string;
  content: string;
}

export const CopyText = ({ label, content }: CopyTextProps) => {
  const [iconToShow, setIconToShow] = useState<'copy' | 'copied'>('copy');

  return (
    <div className="flex items-center gap-1">
      <Button
        variant="ghost"
        className="p-2"
        onClick={() => {
          navigator.clipboard.writeText(content ?? '');
          setIconToShow('copied');

          setTimeout(() => {
            setIconToShow('copy');
          }, 2000);
        }}
      >
        {iconToShow === 'copy' ? <CopyIcon height="18" /> : <CheckIcon height="18" />}
      </Button>
      <span>{label}</span>
    </div>
  );
};
